import React from 'react';

const UserDetailModal = ({ isOpen, onClose, user }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-2xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Artist Details</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-lg font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    <div className="flex mb-4 gap-8">
                        <img src={user.profile_picture} alt="Profile" className="w-20 h-20 rounded-full mr-4" />
                        <div>
                            <h3 className="text-2xl font-bold">
                                {user.first_name} {user.last_name}
                                {user.title ? ` (${user.title})` : ""}
                            </h3>
                            <p className="text-gray-600">{user.email}</p>
                            <div><strong>Verified:</strong> {user.verified ? 'Yes' : 'No'}</div>
                            <div><strong>Status:</strong> {user.deleted ? "Active" : "Non-Active"}</div>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">

                        <div><strong>City:</strong> {user.city ? user.city : "NA"}</div>
                        <div><strong>Country:</strong> {user.country ? user.country : "NA"}</div>
                        <div><strong>Instagram:</strong> {user.instagram ? user.instagram : "NA"}</div>
                        <div><strong>Website:</strong> {user.web_link ? user.web_link : "NA"}</div>
                        <div><strong>Twitter:</strong> {user.twitter ? user.twitter : "NA"}</div>
                        <div><strong>Country:</strong> {user.country ? user.country : "NA"}</div>
                        {/* Add more fields as necessary */}
                    </div>

                    <div class="relative flex pt-5 items-center">
                        <div class="flex-grow border-t border-gray-400"></div>
                        <span class="flex-shrink mx-4 text-gray-400">Description</span>
                        <div class="flex-grow border-t border-gray-400"></div>
                    </div>

                    <div className='mt-0'>
                        <p>{user.description ? user.description : "NA"}</p>
                    </div>

                    <div className="mt-4 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetailModal;
